import { createSlice } from '@reduxjs/toolkit';
import { callerCreator } from '../callerCreator';

const initialState = {
  documents: {
    loading: true,
    error: null,
    documents: [],
  },

};

export const usefulDocumentsSlice = createSlice({
  name: 'usefulDocuments',
  initialState,
  reducers: {
    getDocumentsPending: (state) => {
      state.documents.loading = true;
      state.documents.error = null;
    },
    getDocumentsRejected: (state, { payload }) => {
      state.documents.loading = false;
      state.documents.error = payload;
    },
    getDocumentsSuccess: (state, { payload }) => {
      state.documents.loading = false;
      state.documents.documents = payload;
    },
  },
});

export default callerCreator(usefulDocumentsSlice.actions);
